<router-outlet></router-outlet>
<p-toast position="top-right" life="10000000"></p-toast>
<p-confirmPopup></p-confirmPopup>
<p-blockUI [blocked]="block">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>
